module.exports = function () {
  this.app.$on('redeemCode', event => {
    if (!event.code.replace(/\s/g, '').length) {
      this.app.flash = { notice: 'error', type: 'redeem', message: 'Invalid promo code.' }
      return
    }

    // this.sdk.post('/promo/redeem', {
    this.sdk.post('/discountcode/redeem', {
      deviceId: this.session.token,
      token: this.session.token,
      code: event.code
    }, response => {
      if (!response.error) {
        if (response.type === 'discount') {
          // this.app.flash = { notice: 'success', type: 'redeem', message: this.app.$t('events.successRedeem') + ' ' + event.code }
          if (!response.data.isWidget) {
            this.app.flash = { notice: 'error', type: 'redeem', message: this.app.$t('events.invalidDiscount') }
            return
          }
          let now = Math.floor(Date.now() / 1000)
          let start = response.data.start
          let end = response.data.end
          if (now >= start && now <= end) {
            this.app.$emit('redeemCodeSuccess', response)
          } else {
            this.app.flash = { notice: 'error', type: 'redeem', message: this.app.$t('events.expiredDiscount', {code: event.code}) }
          }
        } else {
          if (response.error) {
            let message = response.error.message || ''
            if (message.indexOf('</html>')) {
              message = this.app.$t('events.invalidPromo')
            }
            this.app.flash = { notice: 'error', type: 'redeem', message: message }
            this.app.$emit('invalidPromoCode', response.message)
            return
          }
          this.app.$emit('refreshCredits', this.session.token, {
            callback: (res) => {
              if (res.error) {
                this.app.flash = { notice: 'error', type: 'redeem', message: res.error.message }
                this.app.$emit('redeemCodeFailed', res.error.message)
              } else {
                this.app.flash = { notice: 'success', type: 'redeem', message: this.app.$t('events.successRedeem') + ' ' + event.code }
                this.app.$emit('redeemCodeSuccess', res.credits)
              }
            }
          })
        }
      } else {
        // let message = response.error.message
        // let message = response.message
        // if (message.indexOf('</html>')) {
        //   message = this.app.$t('events.invalidPromo')
        // }
        this.app.flash = { notice: 'error', type: 'redeem', message: this.app.$t('events.invalidDiscount') }
        // this.app.$emit('invalidPromoCode', response.message)

        if (response.error.message === 'Invalid promo code') {
          this.app.$emit('invalidPromoCode', response.message)
        }
      }
    // })
    }, '/1.1')
  })

  this.app.$on('showRedeemSuccess', code => {
    this.app.flash = {
      notice: 'success',
      type: 'redeem',
      message: `${this.app.$t('events.successRedeem')} <b>${code}</b>`
    }
  })
}



// WEBPACK FOOTER //
// ./src/events/redeem-code.js